'use strict';
var BASWebServices;
(function (BASWebServices) {
    var UrlFilter = (function () {
        function UrlFilter() {
        }
        UrlFilter.Factory = function () {
            return function (input) {
                if (angular.isArray(input)) {
                    var filtered = [];
                    angular.forEach(input, function (url) {
                        filtered.push(UrlFilter.filter(url));
                    });
                    return filtered;
                }
                else if (angular.isString(input)) {
                    return UrlFilter.filter(input);
                }
                else if (input === 'undefined') {
                    return null;
                }
                else if (input === undefined) {
                    return null;
                }
                else if (input.toString().lastIndexOf("http://") != -1 ||
                    input.toString().lastIndexOf("https://") != -1) {
                    return UrlFilter.filter(input.toString());
                }
                else {
                    return input;
                }
            };
        };
        UrlFilter.filter = function (url) {
            return url.substring(url.lastIndexOf("/") + 1);
        };
        return UrlFilter;
    }());
    BASWebServices.UrlFilter = UrlFilter;
})(BASWebServices || (BASWebServices = {}));
//# sourceMappingURL=UrlFilter.js.map